//todo:: remove all the usages of the document, we need it to be SSR friendly
export default class InitStaticSections {
  constructor() {
    Salla.event.on('twilight::before.ready', () => this.renderAll());
  }
  async renderAll() {
    // Register auto-mount first so hook listeners are attached before any await.
    // On first visit or after "Clear site data", component scripts may load before
    // lang/config settle; registering here ensures mount runs when the hook is ready.
    Salla.hooks.renderAutoComponents([
      { hook: 'product:single.description', tag: 'salla-delivery-promise', canRender: () => (Salla.url.is_page('product.single') && Salla.config.get('store.features', []).includes('delivery-promises'))},
      { hook: 'product:single.description', tag: 'salla-loyalty-banner', canRender: () => (Salla.url.is_page('product.single') && Salla.config.get('store.features', []).includes('loyalty-system'))},
      { hook: 'product:single.form.end', tag: 'salla-fulfillment-methods', canRender: () => (Salla.url.is_page('product.single') && Salla.config.get('store.features', []).includes('delivery-promises'))},
      { hook: 'body:end', tag: 'salla-cookies-bar', canRender: () => Salla.config.get('store.features')?.includes('website-cookies') },
      { hook: 'body:end', tag: 'salla-bullet-delivery', canRender: () => Salla.config.get('store.features')?.includes('bullet-delivery-v2') && Salla.config.get('store.settings.bullet_delivery.enabled') === true },
    ]);

    await Salla.lang.onLoaded();
    this.renderAppInstall();
    this.renderEdit();
    this.applyContentCopyright();
    this.renderTemplateStore();

    if (!Salla.helpers.isIframe()) {
      this.renderMaintenance();
      this.renderThemePreview();
    }
  }



  renderMaintenance() {
    if (!Salla.config.get('maintenance')) {
      return;
    }

    document.body.classList.add('has-maintenance-bar');
    if (document.querySelector('salla-maintenance-alert')) {
      Salla.logger.warn('salla-maintenance-alert element Existed before!');
      return;
    }

    document.body.prepend(document.createElement('salla-maintenance-alert'));
  }

  renderTemplateStore() {
    if (!Salla.config.get('store.template')) {
      return;
    }

    document.body.classList.add('has-bottom-alert');
    if (document.querySelector('salla-bottom-alert')) {
      Salla.logger.warn('salla-bottom-alert element Existed before!');
      return;
    }

    document.body.append(document.createElement('salla-bottom-alert'));
  }

  renderAppInstall() {
    if (!Salla.config.get('store.app_install_prompt') || !Salla.config.get('store.apps') || Salla.storage.get('app_install_prompt_disabled') || Salla.config.isMobileApp()) {
      return;
    }

    document.body.classList.add('has-app-install-alert');
    if (document.querySelector('salla-app-install-alert')) {
      Salla.logger.warn('salla-app-install-alert element Existed before!');
      return;
    }

    document.body.append(document.createElement('salla-app-install-alert'));
  }
  renderThemePreview() {
    if (Salla.config.get('theme.mode') !== 'preview') {
      return;
    }
    document.body.classList.add('has-preview-bar');
    if (document.querySelector('#s-theme_preview_bar')) {
      Salla.logger.warn('#s-theme_preview_bar element Existed before!');
      return;
    }
    let alertElement = document.createElement('div');
    alertElement.id = 's-theme_preview_bar';
    alertElement.setAttribute('style', 'display: flex; justify-content: space-between; text-align: center; background-color: #232323; color: #fff; padding: 10px; font-size: 0.875rem; line-height: 1.25rem; position: relative;');
    alertElement.innerHTML = `
              <div style="display:flex; align-items:center;">
                <img width="32" src="https://cdn.salla.network/images/logo/logo-light.svg">
                <span style="margin:0 10px;">${Salla.lang.get('blocks.header.preview_mode')}: <span style="background:rgba(255,255,255,0.25);border-radius:15px; padding:2px 15px 4px">${Salla.config.get('theme.name')}</span></span>
              </div>
              <a href="${Salla.url.get('preview_theme/cancel/preview')}" style="line-height:32px; width:32px;"><i class="sicon-cancel"></i></a>
            `;
    document.body.prepend(alertElement);
  }

  /**
   * @deprecated
   */
  renderEdit() {
    let edit = Salla.config.get('edit');
    if (!edit) {
      return;
    }
    if (document.querySelector('#s-edit-alert')) {
      Salla.logger.warn('#s-edit-alert element Existed before!');
      return;
    }
    let alertElement = document.createElement('div');
    alertElement.id = 's-edit-alert';
    alertElement.innerHTML = `
              <a href="${edit}" style="display:block; background-color:${Salla.config.get('theme.color.primary', '#5cd5c4')}; color:${Salla.config.get('theme.color.reverse', '#fff')}; padding: 10px; text-align:center; font-size: 0.875rem; line-height: 1.25rem;">
                <i class="sicon-edit"></i> 
                ${Salla.lang.get('pages.products.quick_edit')}
              </a>
            `;
    document.body.prepend(alertElement);
  }

  applyContentCopyright() {
    if (!Salla.config.get('store.settings.content_copyright')) {
      return;
    }

    // Helper to check if element is an input
    const isInputElement = (element) => {
      if (!element) return false;
      const tagName = element.tagName?.toLowerCase();
      return tagName === 'input' || tagName === 'textarea';
    };

    // Common event prevention (excluding inputs)
    const preventEvents = ['contextmenu', 'selectstart', 'copy'];
    preventEvents.forEach((event) => {
      document.addEventListener(event, (e) => {
        if (!isInputElement(e.target)) {
          e.preventDefault();
        }
      });
    });

    // Prevent common dev tools shortcuts
    document.addEventListener('keydown', (e) => {
      const key = e.key.toLowerCase();
      const blockedCombos = (
        key === 'f12' ||
        (e.ctrlKey && e.shiftKey && ['i', 'j', 'c'].includes(key)) ||
        (e.ctrlKey && key === 'u')
      );
      if (blockedCombos) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    // Inject protection styles (excluding inputs)
    const style = document.createElement('style');
    style.textContent = `
            body {
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }
            input, textarea {
                -webkit-touch-callout: auto;
                -webkit-user-select: auto;
                -moz-user-select: auto;
                -ms-user-select: auto;
                user-select: auto;
            }
            img {
                pointer-events: none;
                -webkit-user-drag: none;
            }
        `;
    document.head.appendChild(style);
  }
}